// Mock data for Andy Watson IT website

export const COMPANY = {
  name: "Andy Watson IT",
  tagline: "Lanarkshire's Trusted Digital Studio",
  email: "andywatsonitservices@gmail.com",
  phone: "+44 7764 480795",
  phoneRaw: "+447764480795",
  address: "Lanarkshire, Scotland, UK",
  established: 2001,
};

export const NAV_LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Web Design", href: "/#web-design" },
  { label: "Social Media", href: "/#packages" },
  { label: "Work", href: "/#work" },
  { label: "Process", href: "/#process" },
  { label: "About", href: "/#about" },
  { label: "Areas", href: "/#areas" },
  { label: "FAQ", href: "/#faq" },
  { label: "Contact", href: "/#contact" },
];

export const SERVICES = [
  {
    id: "01",
    title: "Web Design Hamilton, Wishaw & Motherwell",
    short: "Beautiful, fast, conversion-driven websites",
    description:
      "Bespoke web design for businesses in Hamilton, Wishaw, Motherwell and across Lanarkshire — custom websites and e-commerce platforms engineered for speed, accessibility and local search performance.",
    bullets: [
      "Bespoke design systems",
      "Local business & e-commerce sites",
      "Google Business Profile optimisation",
      "Core Web Vitals optimisation",
    ],
    icon: "Monitor",
  },
  {
    id: "02",
    title: "Social Media Marketing Solutions",
    short: "Your dedicated social media manager",
    description:
      "Full social media marketing solutions in Lanarkshire — content strategy, daily posting, community management, reels and reporting across Facebook, Instagram, TikTok and LinkedIn.",
    bullets: [
      "Content strategy & scheduling",
      "Daily community management",
      "Reels, stories & short-form video",
      "Monthly performance reports",
    ],
    icon: "Megaphone",
  },
  {
    id: "03",
    title: "Digital Marketing Lanarkshire",
    short: "Paid ads, SEO & campaigns that convert",
    description:
      "Digital marketing and social media marketing solutions in Hamilton, Wishaw and Motherwell that actually drive leads — paid social, Google Ads, local SEO and performance analytics.",
    bullets: [
      "Meta, TikTok & LinkedIn ads",
      "Google Ads & retargeting",
      "Local SEO & Google Business Profile",
      "Landing pages & conversion tracking",
    ],
    icon: "TrendingUp",
  },
];

export const STATS = [
  { value: "120+", label: "Projects delivered" },
  { value: "24+", label: "Years in Lanarkshire" },
  { value: "98%", label: "Client retention" },
  { value: "24h", label: "Avg. response time" },
];

export const PROCESS = [
  {
    step: "01",
    title: "Discover",
    body: "We start with a no-pressure consultation. We listen, audit and map out the real problem worth solving.",
  },
  {
    step: "02",
    title: "Design",
    body: "Wireframes, prototypes and a polished design system — reviewed with you every step of the way.",
  },
  {
    step: "03",
    title: "Build",
    body: "Clean, modern code. Daily progress updates. Staging environments so you can test as we go.",
  },
  {
    step: "04",
    title: "Launch & Grow",
    body: "We launch, monitor, and stay on as your long-term partner — iterating based on real user data.",
  },
];

export const PROJECTS = [
  {
    title: "Hydrotan",
    url: "https://www.hydrotan.co.uk",
    category: "Beauty & Health",
    tags: ["Shopify", "Branding", "SEO"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.hydrotan.co.uk?w=1400&h=1050",
    result: "+212% online sales in 6 months",
  },
  {
    title: "C Glancey Double Glazing",
    url: "https://www.cglanceydoubleglazing.co.uk",
    category: "Home Improvements",
    tags: ["Next.js", "CMS", "Accessibility"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.cglanceydoubleglazing.co.uk?w=1400&h=1050",
    result: "3.2× more qualified enquiries",
  },
  {
    title: "FieldOps AI",
    category: "SaaS Platform",
    tags: ["React", "FastAPI", "OpenAI"],
    image:
      "https://images.pexels.com/photos/9553905/pexels-photo-9553905.jpeg?auto=compress&cs=tinysrgb&w=1400",
    result: "40% reduction in admin time",
  },
  {
    title: "Front Line Kit Hire",
    url: "https://www.frontlinehire.co.uk/",
    category: "Uniform Hire",
    tags: ["React Native", "Stripe"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.frontlinehire.co.uk?w=1400&h=1050",
    result: "40% increase in sales",
  },
  {
    title: "EC Hummers",
    url: "https://www.echummers.com",
    category: "Limousine Hire",
    tags: ["Bookings", "Search", "SEO"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.echummers.com?w=1400&h=1050",
    result: "#1 ranking for local terms",
  },
  {
    title: "Value Double Glazing",
    url: "https://www.valuedoubleglazing.co.uk",
    category: "Windows & Doors",
    tags: ["Web Design", "SEO", "Lead Gen"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.valuedoubleglazing.co.uk?w=1400&h=1050",
    result: "Steady stream of local enquiries",
  },
  {
    title: "Wishaw Girls Football",
    url: "https://www.facebook.com/wishawgirlsfootball",
    category: "Sports & Community",
    tags: ["Facebook", "Content", "Community"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.facebook.com%2Fwishawgirlsfootball?w=1400&h=1050",
    result: "Growing local club following",
    platform: "facebook",
  },
  {
    title: "C G Double Glazing",
    url: "https://www.facebook.com/cgdoubleglazing",
    category: "Social Media Management",
    tags: ["Facebook", "Lead Gen", "Reels"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.facebook.com%2Fcgdoubleglazing?w=1400&h=1050",
    result: "Engaging local audience daily",
    platform: "facebook",
  },
  {
    title: "Garrion Bridges",
    url: "https://www.facebook.com/garrionbridges",
    category: "Hospitality & Retail",
    tags: ["Facebook", "Content", "Events"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fwww.facebook.com%2Fgarrionbridges?w=1400&h=1050",
    result: "Boosted footfall through socials",
    platform: "facebook",
  },
];

export const TECH_STACK = [
  "React",
  "Next.js",
  "TypeScript",
  "Node.js",
  "FastAPI",
  "Python",
  "PostgreSQL",
  "MongoDB",
  "AWS",
  "Vercel",
  "Shopify",
  "WordPress",
  "Figma",
  "OpenAI",
  "Stripe",
  "Tailwind CSS",
];

export const TESTIMONIALS = [
  {
    name: "Rob",
    role: "Founder, Hydrotan",
    quote:
      "Andy rebuilt our store from the ground up. Sales tripled within six months and the site is genuinely a pleasure to use. He's now our go-to for everything digital.",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Charles",
    role: "Director, C Glancey Double Glazing",
    quote:
      "Professional, transparent, and refreshingly honest about what we did and didn't need. The new website looks brilliant and brings in real enquiries every week.",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Priya Sharma",
    role: "COO, FieldOps AI",
    quote:
      "They built our entire SaaS platform — clean code, fast delivery, and a designer's eye. Easily the best development partner we've worked with.",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80",
  },
];

export const FAQS = [
  {
    q: "Do you offer web design in Hamilton?",
    a: "Yes — web design in Hamilton is one of our core services. Based in the heart of Lanarkshire, we regularly build websites for Hamilton-based businesses, from sole traders and tradespeople to established local companies. Every site is designed from scratch, optimised for Google and built to convert local traffic.",
  },
  {
    q: "Do you offer web design in Wishaw?",
    a: "Absolutely. We work with businesses in Wishaw on new websites, redesigns and ongoing support. As a local Lanarkshire team, we understand the Wishaw market and can meet in person as often as needed to make sure your website reflects your business perfectly.",
  },
  {
    q: "Do you offer web design in Motherwell?",
    a: "Yes — we design and build websites for Motherwell businesses of all sizes. From single-page sites for tradespeople to full e-commerce stores, our web design service in Motherwell is delivered with fixed-quote pricing and a fast turnaround.",
  },
  {
    q: "What do your social media marketing solutions include?",
    a: "Our social media marketing solutions cover strategy, content creation (graphics, photos and short-form video), daily posting, community management, paid social advertising and monthly performance reporting across Facebook, Instagram, TikTok and LinkedIn — all on a 4-week rolling contract with no long-term commitment.",
  },
  {
    q: "Can you act as our social media manager in Lanarkshire?",
    a: "Yes — we work as a dedicated social media manager for businesses across Lanarkshire, handling everything from content planning to daily engagement so you can focus on running your business.",
  },
  {
    q: "How much does a new website cost?",
    a: "Our web design packages start at £99 for a basic 2 page website, £399 for a 4 page website, business websites from £699 and e-commerce sites from £995. We always provide a fixed quote upfront — no surprises. See our Web Design Packages section for full details.",
  },
  {
    q: "How long does a typical project take?",
    a: "A standard marketing website for a Hamilton, Wishaw or Motherwell business takes 3–5 weeks from kick-off to launch. Larger platforms and e-commerce builds typically run 6–12 weeks depending on scope.",
  },
  {
    q: "Do you work with clients outside Lanarkshire?",
    a: "Absolutely. We're proudly based in Lanarkshire but work with clients across the UK, Europe and North America. Most of our process runs remotely with optional in-person workshops.",
  },
  {
    q: "Do you offer digital marketing in Lanarkshire?",
    a: "Yes — our digital marketing service in Lanarkshire covers social media marketing solutions, Meta and Google Ads, local SEO, Google Business Profile management, landing pages and full conversion tracking. Everything measured, everything reported monthly.",
  },
  {
    q: "Will you maintain the site after launch?",
    a: "Yes. We offer affordable care plans covering hosting, updates, security, backups and monthly improvements — so your site keeps performing long after launch day.",
  },
];

export const PACKAGES = [
  {
    name: "Launch",
    price: "£250",
    suffix: "from",
    tagline: "Get your business online",
    description:
      "Perfect for new ventures and sole traders getting started with a consistent, professional social media presence.",
    icon: "Rocket",
    platforms: ["Facebook", "Instagram", "TikTok", "LinkedIn"],
    posts: "Up to 2",
    postsSuffix: "social media posts per week",
    features: [
      "Choice of platforms",
      "Content planning & scheduling",
      "Monthly performance summary",
    ],
  },
  {
    name: "Growth",
    price: "£350",
    suffix: "from",
    tagline: "Scale what's working",
    description:
      "For established businesses ready to step up their audience, engagement and consistency across the main platforms.",
    icon: "TrendingUp",
    popular: true,
    platforms: ["Facebook", "Instagram", "TikTok", "LinkedIn"],
    posts: "Up to 3",
    postsSuffix: "social media posts per week",
    features: [
      "Choice of platforms",
      "Content planning & scheduling",
      "Community management",
      "Monthly performance report",
    ],
  },
  {
    name: "Boost",
    price: "£450",
    suffix: "from",
    tagline: "Stand out from the crowd",
    description:
      "A focused push to maximise reach, engagement and follower growth across your key channels.",
    icon: "Zap",
    platforms: ["Facebook", "Instagram", "TikTok", "LinkedIn"],
    posts: "Up to 5",
    postsSuffix: "social media posts per week",
    features: [
      "Choice of platforms",
      "Content planning & scheduling",
      "Community management",
      "Reels & short-form video",
      "Monthly performance report",
    ],
  },
  {
    name: "Accelerate",
    price: "£650",
    suffix: "from",
    tagline: "Premium, full-service support",
    description:
      "Our most comprehensive social media package — cross-posted across every major channel with a heavy content schedule.",
    icon: "Sparkles",
    platforms: ["Facebook", "Instagram", "TikTok", "LinkedIn"],
    posts: "Up to 7",
    postsSuffix: "social media posts per week",
    features: [
      "All platforms · cross-posting",
      "Content planning & scheduling",
      "Community management",
      "Reels & short-form video",
      "Priority support & strategy",
    ],
  },
];

export const WEB_PACKAGES = [
  {
    name: "Basic",
    price: "£99",
    suffix: "",
    tagline: "2 page website",
    icon: "FileText",
    service: "Website design & build",
    features: [
      "2 professionally designed pages",
      "Mobile-friendly, responsive design",
      "Contact details & click-to-call",
      "Basic on-page SEO setup",
      "Help with domain & hosting",
    ],
  },
  {
    name: "Starter",
    price: "£399",
    suffix: "",
    tagline: "4 page website",
    icon: "LayoutTemplate",
    service: "Website design & build",
    popular: true,
    features: [
      "4 custom designed pages",
      "Mobile-friendly, responsive design",
      "Contact form sent to your inbox",
      "Google Maps & social media links",
      "Local SEO for your area",
    ],
  },
  {
    name: "Business",
    price: "£699",
    suffix: "from",
    tagline: "Business websites",
    icon: "Briefcase",
    service: "Website design & build",
    features: [
      "Bespoke design for your brand",
      "Multiple pages built around your services",
      "Advanced local SEO & Google Business setup",
      "Gallery, reviews & enquiry forms",
      "Easy-to-update content",
    ],
  },
  {
    name: "E-commerce",
    price: "£995",
    suffix: "from",
    tagline: "Online shops",
    icon: "ShoppingCart",
    service: "E-commerce",
    features: [
      "Full online shop with product catalogue",
      "Secure card payments",
      "Stock, orders & delivery options",
      "Mobile-optimised checkout",
      "Training to manage your shop",
    ],
  },
];

export const INDUSTRIES = [
  "Hospitality",
  "Legal",
  "Healthcare",
  "Retail & E-com",
  "Construction",
  "Finance",
  "Education",
  "Tourism",
];

export const CLIENT_SITES = [
  { name: "C Glancey Double Glazing", url: "https://www.cglanceydoubleglazing.co.uk/", logo: "/clients/cglancey.png" },
  { name: "Value Double Glazing", url: "https://www.valuedoubleglazing.co.uk/", logo: "/clients/valuedoubleglazing.jpg" },
  { name: "Frontline Hire", url: "https://www.frontlinehire.co.uk/", logo: "/clients/frontlinehire.png" },
  { name: "East Coast Hummers", url: "https://www.echummers.com/", logo: "/clients/echummers.png", darkTile: true },
  { name: "Cottage Boat of Garten", url: "https://cottageboatofgarten.co.uk/", logo: "/clients/cottageboatofgarten.png" },
  { name: "Garrion Bridges Garden Centre", url: "https://www.garrionbridgesgardencentre.co.uk/", logo: "/clients/garrionbridges.jpg" },
  { name: "Hydro Tan", url: "https://www.hydrotan.co.uk/", logo: "/clients/hydrotan.png" },
  { name: "Sun Shack", url: "https://www.sunshack.co.uk/", logo: "/clients/sunshack.png" },
];

export const BUNDLE_DISCOUNT = 0.05;

export const BUNDLES = [
  { name: "Starter Bundle", web: "Basic", webPrice: 99, social: "Launch", socialPrice: 250, tagline: "2 page website + up to 2 posts a week", from: true },
  { name: "Growth Bundle", web: "Starter", webPrice: 399, social: "Growth", socialPrice: 350, tagline: "4 page website + up to 3 posts a week", popular: true, from: true },
  { name: "Business Bundle", web: "Business", webPrice: 699, social: "Boost", socialPrice: 450, tagline: "Business website + up to 5 posts a week", from: true },
];

export const NEW_PROJECTS = [
  {
    title: "Sun Shack Technical",
    url: "https://sunshacktechnical.co.uk/",
    category: "Software Solutions",
    tags: ["Web Design", "Responsive", "SEO"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fsunshacktechnical.co.uk%2F?w=1400&h=1050",
    result: "New website design & build",
  },
];
